import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function CheckIcon(props: SVGProps<any>): ReactElement {
	return (
		<BaseIcon {...props}>
			<path
				d="m20.25 6.75-10.5 10.5L4.5 12"
				stroke="currentColor"
				strokeWidth="2.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</BaseIcon>
	);
}
